import React, { Component } from 'react';
import qs from 'qs';

class TrackingCTASG extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let email = ''

        if(location.search){
            const qsparse = qs.parse(location.search.substr(1));
            email = qsparse.email
        }

        this.state = {
            orderName: props.params.gsrid,
            email
        };
    }

    render() {
        const { orderName, email } = this.state;

        return (
          <div className="row sunwaypal-row-wrapper sunwaypal-wrapper" style={{height: '150px', padding: '50px 0'}}>
            <div className="col-xs-8">
              Click here to view the updated delivery status for your order.
            </div>
            <div className="col-xs-4">
              <a className="btn-postcode-checker btn btn-default btn-block" target="_blank" href={`https://giftr.sg/pages/track-order-thank-you?utm_source=thank-you-page&utm_medium=iframe-widget&utm_campaign=self-serve-order-tracking&email=${email}&order_name=${orderName}`}>Order Tracking Page</a>
            </div>
          </div>
        );
    }
}

export default TrackingCTASG;
